import { useFindUserInLogixQuery } from "@/services/logix";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "components/ui/card";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/ui/tooltip";
import { Info } from "lucide-react";
import { Controller } from "react-hook-form";
import { FormData } from "../validate-form";

export const UserCard = ({ formMethods, cpf }: any) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = formMethods;

  const onSubmit = (data: FormData) => {
    console.log(data);
  };

  const { data } = useFindUserInLogixQuery(cpf);

  formMethods.setValue("name", data?.name);
  formMethods.setValue("cpf", data?.cpf);
  formMethods.setValue("cost_center", data?.cost_center);
  formMethods.setValue("store", data?.company);
  formMethods.setValue("position", data?.position);
  formMethods.setValue("register", data?.register);
  formMethods.setValue("situation", data?.situation);

  return (
    <Card x-chunk="A card with a form to edit the product details">
      <CardHeader>
        <CardTitle>Usuário</CardTitle>
        <CardDescription>
          Digite os dados do usuário que deseja solicitar acesso
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div className="flex gap-6">
            <div className="flex gap-3 w-1/2">
              <div className="flex-1 flex flex-col gap-1">
                <Label htmlFor="cpf" className="flex items-center gap-2">
                  CPF
                  <Tooltip>
                    <TooltipTrigger>
                      <Info className="cursor-pointer" />
                    </TooltipTrigger>
                    <TooltipContent className="bg-black bg-opacity-75 text-white p-1 rounded shadow-lg">
                      <div className="relative">
                        <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-3 h-3 bg-black bg-opacity-75 rotate-45"></div>
                        Digite o CPF e aguarde a busca e validação do usuário
                        automática
                      </div>
                    </TooltipContent>
                  </Tooltip>
                </Label>
                <Controller
                  name="cpf"
                  control={control}
                  render={({ field }) => (
                    <Input
                      {...field}
                      value={field.value}
                      disabled
                      hasError={errors.cpf}
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                      className="input-class"
                      placeholder="000.000.000-00"
                    />
                  )}
                />
                {errors.cpf && (
                  <p className="text-red-500 text-sm">{errors.cpf.message}</p>
                )}
              </div>
            </div>
            <div className="flex gap-3 w-1/2">
              <div className="flex-1 flex flex-col gap-1">
                <Label htmlFor="nome">Nome</Label>
                <Input
                  id="nome"
                  type="text"
                  disabled={true}
                  value={data?.name}
                  placeholder="Nome Completo"
                  {...register("name")}
                  className="w-full"
                />
                {errors.name && (
                  <p className="text-red-500 text-sm">{errors.name.message}</p>
                )}
              </div>
            </div>
          </div>

          <div className="flex gap-6">
            <div className="flex gap-3 w-1/2">
              <div className="flex-1 flex flex-col gap-1">
                <Label htmlFor="matricula">Matrícula</Label>
                <Input
                  id="matricula"
                  type="text"
                  disabled={true}
                  placeholder="000000"
                  value={data?.register}
                  {...register("matricula")}
                  className="w-full"
                />
                {errors.matricula && (
                  <p className="text-red-500 text-sm">
                    {errors.matricula.message}
                  </p>
                )}
              </div>
            </div>
            <div className="flex gap-3 w-1/2">
              <div className="flex-1 flex flex-col gap-1">
                <Label htmlFor="cargo">Cargo</Label>
                <Input
                  id="cargo"
                  type="text"
                  placeholder="Cargo"
                  value={data?.position}
                  disabled={true}
                  {...register("cargo")}
                  className="w-full"
                />
                {errors.cargo && (
                  <p className="text-red-500 text-sm">{errors.cargo.message}</p>
                )}
              </div>
            </div>
          </div>

          <div className="flex gap-6">
            <div className="flex gap-3 w-1/2">
              <div className="flex-1 flex flex-col gap-1">
                <Label htmlFor="matricula">Situação</Label>
                <Input
                  id="situation"
                  type="text"
                  disabled={true}
                  placeholder=""
                  value={data?.situation}
                  {...register("situation")}
                  className="w-full"
                />
                {errors.situation && (
                  <p className="text-red-500 text-sm">
                    {errors.situation.message}
                  </p>
                )}
              </div>
            </div>
            <div className="flex gap-3 w-1/2">
              <div className="flex-1 flex flex-col gap-1">
                <Label htmlFor="cost_center">Centro de Custo</Label>
                <Input
                  id="cost_center"
                  type="text"
                  placeholder=""
                  value={data?.cost_center}
                  disabled={true}
                  {...register("cost_center")}
                  className="w-full"
                />
                {errors.cost_center && (
                  <p className="text-red-500 text-sm">
                    {errors.cost_center.message}
                  </p>
                )}
              </div>
            </div>
          </div>
        </form>
      </CardContent>
      {/* <CardFooter className="flex justify-end">
        <Button type="submit" size="sm">
          Salvar
        </Button>
      </CardFooter> */}
    </Card>
  );
};
